const headerComp = () => import("./header/index.vue");
const footerComp = () => import("./footer/index.vue");

import TransitionPage from "@/components/home/TransitionPage";

export default {
  name: "app",
  components: {
    headerComp,
    footerComp,
    TransitionPage,
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
